import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { Spinner } from "@shopify/polaris";

import { withErrorBoundary } from "lib/hoc";

import { OperatorUpdatePlanChargebee, OperatorUpdatePlanShopify } from "./modules/operator/features";
import ProviderUpdatePlanStripe from "./modules/vendor/features/plan/updatePlan";

const { userKey } = constant;
const { operator, provider } = userKey;

const UpdatePlan = () => {
  const { currentUser, isLoading, history } = useContext(PrivateContext);

  const { isChargebee = false, isStripe = false } = (currentUser && currentUser.plan) || {};

  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner />;
    }
    if (role === operator) {
      return isChargebee ? <OperatorUpdatePlanChargebee /> : <OperatorUpdatePlanShopify />;
    }

    if (role === provider) {
      if (!isStripe) {
        return history.push("/");
      }
      return <ProviderUpdatePlanStripe />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const UpdatePlanComponent = getComponent(currentUserRole);
  return UpdatePlanComponent;
};

export default withErrorBoundary(UpdatePlan);
